import { render, staticRenderFns } from "./BusRiskAreaConfigModal__Style#Drawer.vue?vue&type=template&id=80b2795e&scoped=true&"
import script from "./BusRiskAreaConfigModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BusRiskAreaConfigModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BusRiskAreaConfigModal__Style#Drawer.vue?vue&type=style&index=0&id=80b2795e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b2795e",
  null
  
)

export default component.exports